import { Form } from 'antd';
import { Textarea } from '@admin-panel/ui';
import { ProductRecommendationsSection } from '../ProductRecommendationsSection';
import { SectionHeading, labelNode } from '../helpers';
import type { ProductRecommendationItem } from '../types';

type PdpContentSectionProps = {
  showHeading: boolean;
  showMetadata: boolean;
  recommendations: Array<ProductRecommendationItem>;
  onUpdateRecommendation: (
    recommendationIndex: number,
    updater: (current: ProductRecommendationItem) => ProductRecommendationItem,
  ) => void;
  onAddRecommendation: () => void;
  onRemoveRecommendation: (recommendationIndex: number) => void;
  onRemoveMappedProduct?: (recommendationIndex: number, productId: string) => void;
  onOpenProductPicker: (recommendationIndex: number, productType: string) => void;
};

const PdpContentSection = ({
  showHeading,
  showMetadata,
  recommendations,
  onUpdateRecommendation,
  onAddRecommendation,
  onRemoveRecommendation,
  onRemoveMappedProduct,
  onOpenProductPicker,
}: PdpContentSectionProps) => (
  <section className="space-y-3">
    {showHeading ? <SectionHeading title="PDP Content" /> : null}
    {!showMetadata ? (
      <Form.Item label={labelNode('Blurb')} name="blurb" style={{ marginBottom: 0 }}>
        <Textarea placeholder="Styling blurb" rows={6} className="min-h-[120px]" />
      </Form.Item>
    ) : null}
    <ProductRecommendationsSection
      showHeading={false}
      recommendations={recommendations}
      onUpdateRecommendation={onUpdateRecommendation}
      onAddRecommendation={onAddRecommendation}
      onRemoveRecommendation={onRemoveRecommendation}
      onRemoveMappedProduct={onRemoveMappedProduct}
      onOpenProductPicker={onOpenProductPicker}
    />
  </section>
);

export default PdpContentSection;
